// extracted by mini-css-extract-plugin
export var col = "style-module--col--b28b0";
export var orange = "style-module--orange--2f0e9";
export var purple = "style-module--purple--01a57";
export var row = "style-module--row--60c54";
export var target = "style-module--target--c658f";